module.exports = __webpack_public_path__ + "img/step04_b_stand_power_left_rear_leg.f7b38366.png";